import { getQuery } from '@/util/url';

export function hasClass(el, className) {
  // 开始或空白字符+类名+空白字符或结束
  let reg = new RegExp('(^|\\s)' + className + '(\\s|$)');
  // 测试元素是否有该类名，返回布尔值
  return reg.test(el.className);
}

export function addClass(el, className) {
  if (hasClass(el, className)) {
    return;
  }
  // 以空白符为切割位置切割生成新数组
  let newClass = el.className.split(' ');
  // 数组中加入新类名
  newClass.push(className);
  // 将数组元素放入一个字符串，以空白符间隔
  el.className = newClass.join(' ');
}

// 针对微信分享所做处理
export function genLinkBySSR(route, args) {
  let ssr = args || window.location.hash.split('?')[1] || '';
  route = route || '';
  let link = window.location.origin + location.pathname;
  if (ssr) {
    link += `?_=${route}$${ssr}&back=home`;
  }
  return link;
}

export function getEnv() {
  let ua = navigator.userAgent.toLowerCase();
  let browser = 'default';
  let appType = {
    mqq: ua.indexOf('_sq_') > -1 || false,
    wx: ua.indexOf('micromessenger') > -1 || false,
    jdApp: ua.indexOf('jdapp') > -1 || false,
    jrApp: ua.indexOf('jdjr') > -1 || ua.indexOf('android-async-http') > -1 || false,
    wyApp: ua.indexOf('walletclient') > -1 || false,
    jdStock: ua.indexOf('jdstock') > -1 || false
  };
  for (let i in appType) {
    if (appType[i]) {
      browser = i;
    }
  }
  return browser;
}

export const browserEnv = getEnv();

export function isIphonex() {
  let u = navigator.userAgent;
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  let flag = false;
  if (isIOS) {
    if (window.screen.height == 812 && window.screen.width == 375) {
      flag = true;
      //是iphoneX
    } else if (window.screen.height == 896 && window.screen.width == 414) {
      //是iphone xs max
      flag = true;
    } else {
      flag = false;
      //不是iphoneX
    }
  }
  return flag;
}

export function rdpJDBuriedPoint() {
  try {
    // if (window.rdpJDBuriedPoint && logKey) {
    //   window.rdpJDBuriedPoint('yydw_free_store', logKey);
    // }
  } catch (error) {
    console.log(error);
  }
}

export function MPingClick(opts = {}) {
  try {
    const { eventId, eventParam } = opts;
    if (eventId && eventParam) {
      var click = new window.MPing.inputs.Click(eventId); // 构造click请求
      click.event_param = eventParam; // 设置click的参数
      click.updateEventSeries(); // 更新事件串
      var mping = new window.MPing(); // 构造上报实例
      mping.send(click); // 上报click
    }
  } catch (error) {
    console.log(error);
  }
}

export function isJdNavFun($route) {
  const qs = getQuery();
  let showJd = false;
  if ($.device && $.device.jdapp) {
    if ($route && $route.query && $route.query.nav === 'jd') {
      showJd = true;
    } else if (qs.nav === 'jd') {
      showJd = true;
    }
  }
  return showJd;
}

export function hasNavFun($route) {
  const qs = getQuery();
  let hasNav = true;
  if ($.device && $.device.jdapp) {
    if ($route && $route.query && $route.query.nonav === 'yes') {
      hasNav = false;
    } else if (qs.nonav === 'yes') {
      hasNav = false;
    }
  }
  return hasNav;
}

export function delay(cb, delay) {
  const stt = setTimeout(function() {
    clearTimeout(stt);
    cb();
  }, delay);
}

export function isJRAppKPL() {
  const ua = window.navigator.userAgent;
  const uaLower = ua.toLowerCase();
  const jdjr = /jdjr/.test(uaLower); //金融app
  const isKepler = /kepler/.test(uaLower) && jdjr; //金融app内开普勒
  return isKepler;
}

export function getStaticConfig(key, id) {
  let rst = null;
  if (!id) {
    id = 'data_source_100001014';
  }

  try {
    rst = window[id][key];
  } catch (error) {
    console.log(error);
  }

  return rst;
}

export function isMiniProgram() {
  let rst = false;
  try {
    const qs = getQuery();
    if (qs && qs.miniprogram) {
      rst = true;
      sessionStorage.__miniprogram__ = '1';
    } else if (sessionStorage.__miniprogram__ === '1') {
      rst = true;
    }
  } catch (e) {
    console.log(e);
  }

  if (typeof window.__wxjs_environment !== 'undefined' && window.__wxjs_environment) {
    return window.__wxjs_environment === 'miniprogram';
  }

  return rst;
}

export function getCookie(cookie_name) {
  var allcookies = document.cookie;
  //索引长度，开始索引的位置
  var cookie_pos = allcookies.indexOf(cookie_name);

  // 如果找到了索引，就代表cookie存在,否则不存在
  if (cookie_pos != -1) {
    // 把cookie_pos放在值的开始，只要给值加1即可
    //计算取cookie值得开始索引，加的1为“=”
    cookie_pos = cookie_pos + cookie_name.length + 1;
    //计算取cookie值得结束索引
    var cookie_end = allcookies.indexOf(';', cookie_pos);

    if (cookie_end == -1) {
      cookie_end = allcookies.length;
    }
    //得到想要的cookie的值
    var value = unescape(allcookies.substring(cookie_pos, cookie_end));
  }
  return value;
}

//判断对象是否为空
export function isEmptyObj(text) {
  if (typeof text == 'object') {
    //判断是否为空对象
    for (var x in text) {
      return false;
    }
    return true;
  } else {
    if (text == null || text == undefined || text == 'undefined' || text == '' || text == 'null') {
      return true;
    } else {
      return false;
    }
  }
}

// 图片处理

export function lowQualityImg(initImg) {
  console.log('initImg', initImg);
  if (initImg.indexOf('360buyimg.com') > -1 && initImg.indexOf('/jfs') > -1) {
    let lowImg = initImg.replace('/jfs', '/s400x400_jfs') + '!q70';
    return lowImg;
  } else {
    return initImg;
  }
}
